import { combineEpics } from 'redux-observable';

import { credentialsEpic } from '@bolteu/redux-session';

import { accountEpic } from 'rdx/account/epics';
import { analyticEpic } from 'rdx/analytics/epics';
import { applicationEpic } from 'rdx/application/epics';
import { menuEpic } from 'rdx/menu';
import { offlinePeriodsEpic } from 'rdx/offlinePeriods';
import { passwordEpic } from 'rdx/password';
import { promotionsPermissionsEpic } from 'rdx/promotions/epics';
import { scheduleEpic } from 'rdx/schedule';
import { sessionEpic } from 'rdx/session/epics';
import { supportEpic } from 'rdx/support';
import { targetingParametersEpic } from 'rdx/targetingParameters/epics';

export const rootEpic = combineEpics(
  accountEpic,
  credentialsEpic,
  menuEpic,
  passwordEpic,
  scheduleEpic,
  supportEpic,
  sessionEpic,
  targetingParametersEpic,
  analyticEpic,
  applicationEpic,
  promotionsPermissionsEpic,
  offlinePeriodsEpic,
);
